import { render, staticRenderFns } from "./NeedMapRightSection.vue?vue&type=template&id=2056ed0c&scoped=true"
import script from "./NeedMapRightSection.vue?vue&type=script&lang=js"
export * from "./NeedMapRightSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056ed0c",
  null
  
)

export default component.exports